import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Input, Tabs } from "antd"
import { useTripSearch } from "hooks/useTripSearch"
import { useTranslation } from "react-i18next"
import styles from "./ExperiencesHome.module.css"
import { useSelector, useDispatch } from "react-redux"
import { VERIFICATION_STATUS } from "layoutsV2/pro/PersonalInfoLayout/constants"
import { useEffect } from "react"
import { setFormTouched } from "store/proNewListingForms"
import useActiveGuide from "hooks/useActiveClient"

export const ExperiencesHome = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    searchQuery,
    handleSearchChange,
    handleClearSearch,
    activeTab,
    handleTabChange,
    items,
    renderSearchResults,
    createTripHandler,
    handleSearchKeyDown,
    metadata,
    selectedTrip
  } = useTripSearch()
  const { guide } = useSelector((state) => state.user)
  const status = guide?.verification_status
  const isPending = status === VERIFICATION_STATUS.PENDING
  const [active] = useActiveGuide()

  useEffect(() => {
    dispatch(setFormTouched("details", false))
    dispatch(setFormTouched("scheduling", false))
    dispatch(setFormTouched("media", false))
    dispatch(setFormTouched("resources", false))
    dispatch(setFormTouched("location", false))
  }, [dispatch])

  return (
    <div className={styles.searchHeader}>
      <div className="justify-between mb-4xl gap-3">
        <div className={styles.searchContainer}>
          <Input
            className={styles.searchInput}
            placeholder={t("experiences.search_experiences")}
            prefix={<SearchOutlined aria-hidden="true" />}
            suffix={
              searchQuery && (
                <button
                  type="button"
                  onClick={handleClearSearch}
                  className="mt-0 cursor-pointer border-0 bg-transparent p-0"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault()
                      handleClearSearch()
                    }
                  }}
                  aria-label={t("experiences.clear_search")}
                >
                  <CloseOutlined aria-hidden="true" />
                </button>
              )
            }
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyDown}
            aria-label={t("experiences.search_experiences")}
            aria-controls="search-results"
            aria-expanded={!!searchQuery}
            aria-autocomplete="list"
            aria-activedescendant={searchQuery ? "search-results" : undefined}
          />
          <section id="search-results" aria-live="polite" aria-labelledby="search-results-heading">
            <h2 id="search-results-heading" className="visually-hidden">
              {t("experiences.search_results")}
            </h2>
            {renderSearchResults()}
          </section>
        </div>
        <Button
          type="primary"
          size="large"
          onClick={active && !isPending ? createTripHandler : undefined}
          icon={<PlusOutlined aria-hidden="true" />}
          aria-label={t("experiences.add_new_experience")}
          disabled={!active || isPending}
        >
          {t("experiences.add_new_experience")}
        </Button>
      </div>
      <Tabs
        className={styles.tabs}
        activeKey={activeTab}
        onChange={handleTabChange}
        items={items.map((tab) => {
          let count = 0
          if (selectedTrip) {
            count = tab.key === activeTab ? 1 : 0
          } else if (metadata?.status_count) {
            if (tab.key === "1") count = metadata?.status_count?.published || 0
            if (tab.key === "2") count = metadata?.status_count?.draft || 0
            if (tab.key === "3") count = metadata?.status_count?.unpublished || 0
          }
          return {
            ...tab,
            label: `${tab?.label} ${count}`
          }
        })}
      />
    </div>
  )
}
